export default function readCookie(cookieName) {
  // this check is needed for gatsby build
  if (typeof document !== 'undefined' && document.cookie) {
    const testGroupCookie = document.cookie
      .split(';')
      .find(cookie => cookie.includes(cookieName));
    return testGroupCookie && testGroupCookie.split('=')[1];
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/utils/readCookie.js